import { PureComponent } from 'react';

import './ShowMore.style';

export class ShowMore extends PureComponent {
    constructor(props) {
        super(props);

        // Initialize the state with the passed isOpen prop, defaulting to false if not provided
        this.state = {
            isOpen: props.isOpen || false
        };
        this.handleShowAllButtonClick = this.handleShowAllButtonClick.bind(this);
    }

    handleShowAllButtonClick() {
        this.setState(prevState => ({ isOpen: !prevState.isOpen }));
    }

    renderShowAllButton() {
        const { isOpen } = this.state;

        const mods = isOpen ? { isOpen } : {};

        return (
            <button
                onClick={ this.handleShowAllButtonClick }
                block="ShowMore"
                elem="Button"
                mods={ mods }
            >
                { isOpen ? __('Show less') : __('Show more') }
            </button>
        );
    }

    renderContent() {
        const { isOpen } = this.state;
        const { children } = this.props;

        const mods = isOpen ? { isOpen } : {};

        return (
            <div block="ShowMore" elem="Content" mods={ mods }>
                { children }
            </div>
        )
    }

    render() {
        const { mix } = this.props;

        return (
            <div block="ShowMore" mix={ mix }>
                { this.renderContent() }
                { this.renderShowAllButton() }
            </div>
        );
    }
}

export default ShowMore;

